import { render } from "./NotPermission.vue?vue&type=template&id=0b4272da"
import script from "./NotPermission.vue?vue&type=script&lang=js"
export * from "./NotPermission.vue?vue&type=script&lang=js"

import "./NotPermission.vue?vue&type=style&index=0&id=0b4272da&lang=scss"

import exportComponent from "../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__